<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">Autor</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">


          <div v-if="!authorsLoaded" class="h-100 d-flex justify-content-center align-items-center">
            <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
          </div>

          <div v-else class="card card-form">
            <div class="card-body">
              <div class="form-section-header">Neuer Autor</div>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">Name <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('author.name')?'is-invalid':''"
                      v-model="author.name"
                      v-validate="'required'"
                      data-vv-name="name"
                      type="text"
                      placeholder="Autor"
                      ref="nameField"
                      :state="errors.first('name') ? false : null">
                  ></b-form-input>
                  <div v-if="errors.first('name')" class="text-danger">Den Namen bitte eingeben</div>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col sm="3">
                  <label class="col-form-label">Beschreibung <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <ckeditor :editor="editor" v-model="author.description" :config="editorConfig"></ckeditor>
                </b-col>
              </b-row>

              <div class="form-buttons">
                <button type="submit" class="btn btn-link" @click="$router.go(-1)">{{ $t('message.cancel') }} </button>
                <button type="submit" class="btn btn-success" @click="proceed">{{ $t('message.proceed') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import { AUTHORS_REQUEST, AUTHOR_REQUEST_BY_ID, AUTHOR_SAVE, AUTHOR_UPDATE, AUTHOR_GET_NEW_ID } from '@/store/actions/authors';

  export default {
    name: "CreateAuthor",

    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {
          // The configuration of the editor.
        },

        author: {
          name: null,
          description: ''
        },

        newRecord: false
      }
    },

    mounted() {
      if (this.$route.params.id == undefined) {
        this.newRecord = true;
        this.$store.dispatch(AUTHOR_GET_NEW_ID).then(newId => {
          this.author.id = newId;
        })
      } else {
        this.getAuthor(this.$route.params.id);
      }
    },

    methods: {
      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            if (this.newRecord === true) {
              return this.saveAuthor();
            }

            return this.updateAuthor();
          }
        });
      },

      async saveAuthor() {
        await this.$store.dispatch(AUTHOR_SAVE, this.author)
          .then((response) => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullyAdded"),
              type: 'success',
              confirmButtonText: 'OK'
            });
            this.newRecord = false;
            this.$router.push({name: 'AuthorList'});
          })
          .catch(error => {
            console.log(`error ${error}`)
          })
      },

      async updateAuthor() {
        await this.$store.dispatch(AUTHOR_UPDATE, this.author)
          .then((response) => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullyUpdated"),
              type: 'success',
              confirmButtonText: 'OK'
            });

            this.$router.push({name: 'AuthorList'})
          }).catch(error => {
            console.log(`error ${error}`)
          });
      },

      async getAuthor(id) {
        if (id != undefined) {
          this.$store.dispatch(AUTHOR_REQUEST_BY_ID, id).then(author => {
            this.author = author;
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
  }
</script>


<style scoped>

</style>